module.exports = __webpack_public_path__ + "static/media/fuelSystem.e350c82a.svg";